import { useClient } from '../context/ClientContext.tsx';
import { GenericDbCall } from './LambdaApi.js';

export function useUserActions() {
    const { setClientInfo } = useClient();

    async function saveUser(input) {
        const item = {
            UserId: { S: input.userId },
            CognitoUserId: { S: input.cognitoUserId },
            Username: { S: input.username },
            Email: { S: input.email },
            //FirstLoginDatetime: { S: input.firstLoginDatetime.toISOString() },
            //LastLoginDatetime: { S: input.lastLoginDatetime.toISOString() },
            FirstLoginDatetime: { S: new Date(input.firstLoginDatetime).toISOString() },
            LastLoginDatetime: { S: new Date(input.lastLoginDatetime).toISOString() },
            IsActive: { BOOL: input.userIsActive },
            IsAdmin: { BOOL: input.isAdmin },
            //ExpirationDatetime: { S: input.expirationDate.toISOString() },
            //ExpirationDatetime: { S: new Date(input.expirationDate).toISOString() },
            SubscriptionIsActive: { BOOL: input.subscriptionIsActive },
        };

        if (input.clientCode && input.clientCode.trim() !== "") {
            item.ClientCode = { S: input.clientCode };
        }

        await GenericDbCall({
            table: "users",
            operation: "put",
            item,
        });

        // Sync UI state with DB
        const clientInfo = {
            name: input.username,
            organization: input.clientCode ?? null,
            isAdmin: input.isAdmin,
            subscriptionIsActive: input.subscriptionIsActive,
        };
        if (input.expirationDate == null) {
            // null or undefined → no expiration date
            clientInfo.expirationDate = null;
        } else {
            const d = new Date(input.expirationDate);
            clientInfo.expirationDate = isNaN(d.getTime()) ? null : d;
        }
        setClientInfo(clientInfo);
    }

    return { saveUser };
}